<template>
  <v-row>
    <v-col cols="4">
      <p class="pl-0 info-expediente">{{ $t('selectEmplazamientoProductos.emplazamientos') }}</p>
      <v-subheader class="pl-0 mt-2 info-expediente">
        {{ $t('selectEmplazamientoProductos.seleccionaEmplazamientos') }}
      </v-subheader>
      <v-list>
        <v-list-item-group v-model="emplazamientosSeleccionados" multiple>
          <v-list-item
            v-for="(emplazamiento, index) in emplazamientos"
            :key="'emplazamiento' + index"
            :value="emplazamiento.uuid"
            @click.stop="seleccionarEmplazamiento(emplazamiento.uuid)">
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox
                  :input-value="active"
                  :color="subalcance.color"></v-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>{{ emplazamiento.nombre }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ emplazamiento.tipo }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-col>
    <v-col cols="8">
      <v-tabs v-model="tabProductos" :color="subalcance.color" :slider-color="subalcance.color">
        <v-tab
          v-for="emplazamiento in listadoEmplazamientos"
          :key="emplazamiento.tipo"
          :href="'#' + emplazamiento.tipo">
          <span class="primary--text text-no-wrap text-truncate">{{ emplazamiento.tipo }}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabProductos">
        <v-tab-item
          :value="emplazamiento.tipo"
          v-for="emplazamiento in listadoEmplazamientos"
          :key="emplazamiento.tipo">
          <v-row class="mt-3">
            <v-data-table
              :headers="getHeaders(emplazamiento.uuid)"
              :items="listadoProductos(emplazamiento.tipo)"
              :items-per-page="5"
              show-select
              v-model="productosSeleccionados"
              @input="seleccionarProducto"
              :checkbox-color="subalcance.color"
              item-key="uuid"
              class="elevation-1"
              :no-data-text="$t('tabla.sindatos')"
              :footer-props="{ 'items-per-page-text': $t('tabla.filasporpagina') }">
              <template v-slot:item.rgseaa="{ item }">
                {{ item.rgseaa }}
              </template>
              <template
                v-for="header in getHeaders(emplazamiento.uuid).filter(h => h.value !== 'rgseaa')"
                v-slot:[`item.${header.value}`]="{ item }">
                {{
                  (() => {
                    const param = item.params.find((param) => param.nombre === header.value)
                    if (param && param.valor && param.tipo !== 'emplazamiento') {
                      return typeof param.valor[0] === 'object'
                        ? param.valor[0].nombre
                        : param.valor.join(', ')
                    }
                    if (param && param.valor && param.tipo === 'emplazamiento') {
                      return param.displayValue
                    }
                    return ''
                  })()
                }}
              </template>
            </v-data-table>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Datatable from '~/components/Datatable.vue'
export default {
  components: {
    Datatable,
  },
  props: {
    valueEmplazamientos: {
      type: Array,
      default: () => []
    },
    valueProductos: {
      type: Array,
      default: () => []
    },
    emplazamientos: {
      type: Array,
      required: true,
    },
    productos: {
      type: Array,
      required: true,
    },
    subalcance: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tabProductos: '',
      emplazamientosSeleccionados: [],
      productosSeleccionados: [],
    }
  },
  watch: {
    valueEmplazamientos: {
      immediate: true,
      handler(val) {
        this.emplazamientosSeleccionados = Array.isArray(val) ? [...val] : []
      }
    },
    valueProductos: {
      immediate: true,
      handler(val) {
        this.productosSeleccionados = Array.isArray(val) ? [...val] : []
      }
    },
    emplazamientosSeleccionados(val) {
      this.$emit('update:valueEmplazamientos', val)
    },
    productosSeleccionados(val) {
      this.$emit('update:valueProductos', val)
    }
  },
  computed: {
    listadoEmplazamientos() {
      let acc = []
      this.emplazamientos.forEach((emplazamiento) => {
        if (!acc.find((item) => item.tipo === emplazamiento.tipo)) {
          acc.push({ tipo: emplazamiento.tipo, uuid: emplazamiento.uuid })
        }
      })
      return acc
    },
  },
  methods: {
    getHeaders(uuid) {
      const product = this.productos.find((producto) => producto.emplazamiento.uuid === uuid)
      if (!product) return []

      const headers = [
        {
          text: 'rgseaa',
          value: 'rgseaa',
          sortable: false,
        },
        ...Object.values(product.params).map((item) => ({
          text: item.nombre,
          value: item.nombre,
          sortable: false,
        })),
      ]
      //console.log('headers', headers)
      return headers
    },

    listadoProductos(tipo) {
      /*console.log('esto',this.productos
        .filter((producto) => producto.emplazamiento.tipo === tipo)
        .map((producto) => ({
          ...producto,
          rgseaa: producto.emplazamiento?.direccion?.rgseaa || '—',
        })))*/
      return this.productos
        .filter((producto) => producto.emplazamiento.tipo === tipo)
        .map((producto) => ({
          ...producto,
          rgseaa: producto.emplazamiento?.direccion?.rgseaa || '—',
        }))
    },
    seleccionarEmplazamiento(uuidEmplazamiento) {
      const estaSeleccionado = this.emplazamientosSeleccionados.includes(uuidEmplazamiento)

      if (estaSeleccionado) {
        // Deseleccionado: quitar productos asociados
        this.emplazamientosSeleccionados = this.emplazamientosSeleccionados.filter(
          e => e !== uuidEmplazamiento
        )
        this.productosSeleccionados = this.productosSeleccionados.filter(
          producto => producto.emplazamiento.uuid !== uuidEmplazamiento
        )
      } else {
        // Seleccionado: agregar productos del emplazamiento
        this.emplazamientosSeleccionados.push(uuidEmplazamiento)

        const productosAsociados = this.productos.filter(
          producto => producto.emplazamiento.uuid === uuidEmplazamiento
        )
        productosAsociados.forEach(producto => {
          if (!this.productosSeleccionados.some(p => p.uuid === producto.uuid)) {
            this.productosSeleccionados.push(producto)
          }
        })
      }
    },
    seleccionarProducto() {
      // Añadir emplazamiento de cada producto seleccionado
      this.productosSeleccionados.forEach((producto) => {
        const uuidEmplazamiento = producto.emplazamiento.uuid
        if (!this.emplazamientosSeleccionados.includes(uuidEmplazamiento)) {
          this.emplazamientosSeleccionados.push(uuidEmplazamiento)
        }
      })

      // Quitar emplazamientos sin productos seleccionados
      this.emplazamientos.forEach((emplazamiento) => {
        const productosDelEmplazamiento = this.productos.filter(
          (p) => p.emplazamiento.uuid === emplazamiento.uuid
        )

        const algunoSeleccionado = productosDelEmplazamiento.some((p) =>
          this.productosSeleccionados.some(ps => ps.uuid === p.uuid)
        )
        //console.log('Emplazamientos seleccionados:', this.emplazamientosSeleccionados)

        if (!algunoSeleccionado) {
          const index = this.emplazamientosSeleccionados.indexOf(emplazamiento.uuid)
          if (index !== -1) this.emplazamientosSeleccionados.splice(index, 1)
        }
      })
    },
  },
}
</script>
